var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.getLoadingGlobal)?_c('div',{staticClass:"main-content"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1):_vm._e(),(_vm.getLoadingGlobal)?_c('LoadingOverlay'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }